import {AuthState} from './auth/auth.state';
import {DictionaryState} from './dictionary/dictionary.state';
import {DocumentState} from './document/document.state';
import {LocalizationState} from './localization/localization.state';
import {PartnerState} from './partner/partner.state';
import {PasswordPolicyState} from './password-policy/password-policy.state';
import {UserState} from './user/user.state';
import {ProductPgState} from './product-pg/product-pg.state';
import {CoAcquisitionState} from './co-acquisition/co-acquisition.state';
import {TranscoderState} from './transcoder/transcoder.state';
import {BrandsState} from './brands/brands.state';
import {SalesCpiState} from './sales-cpi/sales-cpi.state';
import {TariffElementState} from './tariff-element/tariff-element.state';
import {SalesPgState} from './sales-pg/sales-pg.state';
import {PolicyRegistryState} from './policy-registry/policy-registry.state';
import {AsideState} from './aside/aside.state';
import {SalesCpiAsideState} from './sales-cpi/sales-cpi-aside.state';
import {ProductState} from './product/product.state';
import {ProductCpiState} from './product-cpi/product-cpi.state';
import {PasswordChangeState} from './password-change/password-change.state';
import {PolicyPgState} from './policy-pg/policy-pg.state';
import {ExportXmlState} from './export-xml/export-xml.state';
import {ActiveProductState} from './active-products/active-products.state';
import {ReportsState} from './reports/reports.state';
import {MigratedPoliciesState} from './migrated-policies/migrated-policies.state';
import {RepositoryPoliciesState} from './repository-policies/repository-policies.state';
import {RepositoryPoliciesAsideState} from './repository-policies/repository-policies-aside.state';

export const rootState = [
    AuthState,
    AsideState,
    BrandsState,
    CoAcquisitionState,
    RepositoryPoliciesState,
    RepositoryPoliciesAsideState,
    DictionaryState,
    DocumentState,
    ExportXmlState,
    LocalizationState,
    PartnerState,
    PasswordChangeState,
    PasswordPolicyState,
    PolicyPgState,
    PolicyRegistryState,
    ProductState,
    ProductPgState,
    ProductCpiState,
    ReportsState,
    UserState,
    SalesCpiState,
    SalesCpiAsideState,
    SalesPgState,
    TranscoderState,
    TariffElementState,
    ActiveProductState,
    MigratedPoliciesState,
];
